'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalizedCatalogueCarousel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _sharedSliderJacketCover = require('@bibliocommons/shared-slider-jacket-cover');

var _sharedSliderJacketCover2 = _interopRequireDefault(_sharedSliderJacketCover);

var _carouselBase = require('@bibliocommons/carousel-base');

var _carouselBase2 = _interopRequireDefault(_carouselBase);

var _reactIntl = require('react-intl');

require('../styles/CatalogueCarousel.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CatalogueCarousel = function CatalogueCarousel(_ref) {
  var bibs = _ref.bibs,
      carouselSettings = _ref.carouselSettings,
      headingTag = _ref.headingTag,
      carouselTitle = _ref.carouselTitle,
      carouselTitleLink = _ref.carouselTitleLink;
  return _react2.default.createElement(
    'div',
    { className: 'cp-catalogue-carousel' },
    _react2.default.createElement(
      _carouselBase2.default.BaseCarousel,
      _extends({}, carouselSettings, { titleData: { headingTag: headingTag, carouselTitle: carouselTitle, carouselTitleLink: carouselTitleLink } }),
      bibs.map(function (bib) {
        return _react2.default.createElement(_sharedSliderJacketCover2.default, { key: bib.id, item: bib });
      })
    )
  );
};

CatalogueCarousel.propTypes = {
  carouselSettings: _bcPropTypes.carouselSettingShape,
  carouselTitle: _react.PropTypes.string.isRequired,
  carouselTitleLink: _react.PropTypes.string,
  headingTag: _react.PropTypes.string,
  bibs: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    title: _react.PropTypes.string.isRequired,
    id: _react.PropTypes.string.isRequired,
    format: _react.PropTypes.string.isRequired,
    jacket: _react.PropTypes.shape({
      medium: _react.PropTypes.string.isRequired
    }).isRequired
  }).isRequired).isRequired
};

CatalogueCarousel.defaultProps = {
  bibs: [],
  headingTag: 'h1',
  carouselSettings: {
    buttonBackgroundColor: '#fff',
    breakpointSettings: {
      1000000: {
        showDots: true,
        useTouchArrows: false,
        itemsPerPage: 7,
        gutterSize: '34px',
        partiallyShowOffscreenItems: false
      },
      1280: {
        showDots: true,
        useTouchArrows: false,
        itemsPerPage: 7,
        gutterSize: '34px',
        partiallyShowOffscreenItems: false
      },
      992: {
        showDots: true,
        useTouchArrows: false,
        itemsPerPage: 6,
        gutterSize: '34px',
        partiallyShowOffscreenItems: false
      },
      768: {
        showDots: false,
        useTouchArrows: true,
        itemsPerPage: 5,
        gutterSize: '14px',
        partiallyShowOffscreenItems: true
      },
      576: {
        showDots: false,
        useTouchArrows: true,
        itemsPerPage: 3,
        gutterSize: '34px',
        partiallyShowOffscreenItems: true
      },
      480: {
        showDots: false,
        useTouchArrows: true,
        itemsPerPage: 3,
        gutterSize: '14px',
        partiallyShowOffscreenItems: true
      },
      320: {
        showDots: false,
        useTouchArrows: true,
        itemsPerPage: 2,
        gutterSize: '14px',
        partiallyShowOffscreenItems: true
      }
    }
  }
};

var LocalizedCatalogueCarousel = function LocalizedCatalogueCarousel(_ref2) {
  var messages = _ref2.messages,
      locale = _ref2.locale,
      carouselProps = _objectWithoutProperties(_ref2, ['messages', 'locale']);

  return _react2.default.createElement(
    _reactIntl.IntlProvider,
    { messages: messages, locale: locale },
    _react2.default.createElement(CatalogueCarousel, carouselProps)
  );
};

exports.LocalizedCatalogueCarousel = LocalizedCatalogueCarousel;
LocalizedCatalogueCarousel.propTypes = {
  messages: _react.PropTypes.objectOf(_react.PropTypes.string).isRequired,
  locale: _react.PropTypes.string.isRequired
};

LocalizedCatalogueCarousel.defaultProps = {
  messages: {},
  locale: 'en'
};

exports.default = CatalogueCarousel;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/carousel/catalogue-carousel/lib/components/CatalogueCarousel.component.js
// module id = 991
// module chunks = 3